import type { DomainParents, DomainRouteManifest } from '../router/domain-routes';

export type DomainRouteFactory = (domainParents: DomainParents) => DomainRouteManifest;

const modules = import.meta.glob<{ default: DomainRouteFactory }>('./*/route.manifest.{ts,tsx}', { eager: true });

export const manifestEntries: ReadonlyArray<readonly [name: string, factory: DomainRouteFactory]> = Object.entries(modules)
  .map(([path, mod]) => [path.split('/')[1] ?? path, mod.default] as const)
  .sort(([a], [b]) => a.localeCompare(b));
